import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

const DISMISS_KEY = "popu-pwa-dismissed";

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(DISMISS_KEY) === "1") return;
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      setTimeout(() => setVisible(true), 4000);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const choice = await deferred.userChoice;
    if (choice.outcome === "accepted") {
      localStorage.setItem(DISMISS_KEY, "1");
    }
    setVisible(false);
    setDeferred(null);
  };

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setVisible(false);
  };

  if (!visible || !deferred) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-[380px] z-40 rounded-sm border shadow-2xl p-4 flex items-center gap-3 animate-fade-up"
      style={{ background: "var(--bg)", borderColor: "var(--accent)" }}
      data-testid="install-prompt"
    >
      <div className="w-10 h-10 rounded-sm accent-bg text-white flex items-center justify-center shrink-0">
        <Download size={20} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-bold text-sm leading-tight">Instalá POPU.news</p>
        <p className="text-xs leading-tight" style={{ color: "var(--text-muted)" }}>
          Accedé como app desde tu home, sin abrir el navegador.
        </p>
      </div>
      <button onClick={install} className="btn-accent text-xs px-3 py-2" data-testid="install-prompt-accept">
        Instalar
      </button>
      <button onClick={dismiss} className="p-1 hover:opacity-70" data-testid="install-prompt-dismiss">
        <X size={16} />
      </button>
    </div>
  );
}
